import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
  return await axios.get(url, { params }).then((res) => res.data.data)
}

const useConsignmentSalesYearlyReportRepositories = (params) => {
  const shouldFetch = params?.enabled !== false
  const requestParams = { ...params }
  delete requestParams.enabled

  const hasRequiredParams = Boolean(requestParams.year)

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch && hasRequiredParams
      ? [`${process.env.REACT_APP_INVENTORY_API_URL}/reports/consignment-sales-yearly`, requestParams]
      : null,
    fetcher
  )

  return {
    data,
    isLoading: shouldFetch && hasRequiredParams && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export default useConsignmentSalesYearlyReportRepositories
